import { createAction } from 'redux-act';

import MergedTable from '../../../models/interfaces/layout/MergedTable';
import { Reservation, ReservationSeating, SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import ReservationRejectReason from '../../../models/interfaces/reservation/ReservationRejectReason';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface UpdateReservationPayload extends ReservationPayload {
  pendingReservation: Reservation;
  seating?: ReservationSeating;
  mergedTable?: MergedTable;
}
export const updateReservation = createAction<UpdateReservationPayload>('UPDATE_RESERVATION');

export interface ReservationUpdatedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
  createdMergedTable: MergedTable | null;
}
export const reservationUpdated = createAction<ReservationUpdatedPayload>('RESERVATION_UPDATED');

export interface ReservationUpdateFailedPayload extends TimestampPayload, ReservationPayload {
  rejectReason?: ReservationRejectReason;
}
export const reservationUpdateFailed = createAction<ReservationUpdateFailedPayload>('RESERVATION_UPDATE_FAILED');
